import { Typography as MuiTypography, TypographyProps } from '@mui/material';
import { FC } from 'react';
import {
  COLOR_BY_TYPOGRAPHY_COLOR,
  FONT_SIZE_BY_VARIANT,
  FONT_WEIGHT_BY_VARIANT,
  LINE_HEIGHT_BY_VARIANT,
  MUI_VARIANT_BY_VARIANT,
  TypographyColor,
  TypographyVariant,
} from './typography.styles';

interface Props {
  variant?: TypographyVariant;
  color?: TypographyColor;
  component?: 'span' | 'label';
  maxLines?: number;
  noWrap?: boolean;
}

export const Typography: FC<Props & Omit<TypographyProps, keyof Props>> = ({
  variant = 'p1',
  color = 'textPrimary',
  maxLines,
  noWrap,
  ...props
}) => {
  return (
    <MuiTypography
      variant={MUI_VARIANT_BY_VARIANT[variant]}
      {...props}
      sx={{
        ...props.sx,
        fontFamily: 'Inter',
        whiteSpace: 'pre-wrap',
        color: COLOR_BY_TYPOGRAPHY_COLOR[color],
        fontSize: FONT_SIZE_BY_VARIANT[variant],
        fontWeight: FONT_WEIGHT_BY_VARIANT[variant],
        lineHeight: LINE_HEIGHT_BY_VARIANT[variant],
        ...(maxLines
          ? {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: maxLines,
            }
          : {}),
        ...(noWrap
          ? {
              whiteSpace: 'nowrap',
            }
          : {}),
      }}
    />
  );
};
